import { Select, SelectField, type SelectFieldProps, type SelectProps } from '@nvision/ui';

import { usePricingTypes } from '../../hooks';
import type { PricingType, PricingTypeFilters } from '../../models';

export interface PricingTypeFieldProps extends Omit<SelectProps<PricingType>, 'options'> {
  defaultFilters?: Partial<PricingTypeFilters & { searchParams: { ids: string[] } }>;
  label?: string;
  errorMessage?: SelectFieldProps<PricingType>['errorMessage'];
  isInvalid?: boolean;
}

export const PricingTypeField: React.FC<PricingTypeFieldProps> = ({ defaultFilters, label, ...otherFieldProps }) => {
  const { data, isLoading, updateFilters } = usePricingTypes(defaultFilters);

  if (label) {
    return (
      <SelectField
        {...otherFieldProps}
        label={label}
        placeholder="Select"
        options={data?.list ?? []}
        onInputChange={(search) => updateFilters({ search: { codeDesc: search } })}
        isLoading={isLoading}
      />
    );
  }

  return (
    <Select
      {...otherFieldProps}
      placeholder="Select"
      options={data?.list ?? []}
      onInputChange={(search) => updateFilters({ search: { codeDesc: search } })}
      isLoading={isLoading}
    />
  );
};
